module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAFVBMVEUAAACBh42Bh42Bh42Bh42Bh42Bh43TYrSyAAAABnRSTlMA66uAVBZg/lnaAAAAPUlEQVQI12NQSwOCJAYGhkAQQxTIYAExHBiAQA0sA5IDy4DkQDJgkJbGQAQDiFAZyTApAygjGcgGyxmAGQBBzRRHSn9CmgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_screen1.png
// module id = ZDyb
// module chunks = 9